module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "BMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "BMTNI"
  }, [_vm._v("This book was written over the course of the past decade. In that time, I have been beyond fortunate to receive a great deal of nurturing and support from a great many individuals and institutions. It is a profound delight to acknowledge:")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("My agent, Faye Bender, for her tranquillity and her guidance.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("My editor, Sarah Bowlin, with whom it has been a joy to collaborate, and the rest of the Henry Holt team, especially Leslie Brandon, Kerry Cullen, Lucy Kim, Jason Liebman, and Maggie Richards.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("The editors who assisted me in revising drafts of these stories, especially Halimah Marcus, Benjamin Samuel, and Rob Spillman.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("The publications in which pieces from this book first appeared, some in slightly different form: “The Knowers” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Electric Literature")]), _vm._v("; “The Messy Joy of the Final Throes of the Dinner Party” on PRI’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Selected Shorts")]), _vm._v("; “Life Care Center” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Iowa Review")]), _vm._v("; “The Joined” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Mississippi Review")]), _vm._v("; “Flesh and Blood” and “Children” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tin House")]), _vm._v("; “When the Tsunami Came” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Pinch")]), _vm._v("; “One of Us Will Be Happy; It’s Just a Matter of Which One” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Fairy Tale Review")]), _vm._v("; “Things We Do” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("DIAGRAM")]), _vm._v("; “R” and “How I Began to Bleed Again After Six Alarming Months Without” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Unstuck")]), _vm._v("; “The Worst” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ArtFaccia")]), _vm._v("; “The Beekeeper” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Isthmus")]), _vm._v("; and “Wedding Stairs” in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Slice.")])]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("The Rona Jaffe Foundation, the Whiting Foundation, the Ucross Foundation, and Symphony Space.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("Lisa Graziano of Leapfrog Press, for publishing my first book, and Krista Marino of Delacorte, for publishing my second.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("My teachers and colleagues, current and former, in the Brooklyn College Department of English, including Julie Agoos, L. A. Asekoff, Elaine Brooks, Erin Courtney, Michael Cunningham, James Davis, Joshua Henkin, Janet Moser, and Elissa Schappell, with infinite thanks to Jenny Offill, Ellen Tremper, and Mac Wellman.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("My former classmates in the Brooklyn College MFA program, especially Jeanie Gosline, Andy Hunter, Reese Kwon, Scott Lindenbaum, Elissa Matsueda, Joseph Rogers, and Margaret Zamos-Monteith.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("The searingly insightful members, current and former, of the Imitative Fallacies, including Adam Brown, David Ellis, Tom Grattan, Anne Ray, and Mohan Sikka, with special thanks to Marie-Helene Bertino, Elizabeth Logan Harris, Elliott Holt, and Amelia Kahaney.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("My students, who have graced my classrooms and my life with their curiosity and intelligence.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("My dear friends Sarah Baron, Sarah Brown, Adam Farbiarz, Aysu Farbiarz, David Gorin, Lucas Hanft, Avni Jariwala, Jeremy Kahan, Debra Morris, Jonas Oransky, Laura Perciasepe, Genevieve Randa, Kendyl Salcito, Maisie Tivnan, and Tess Wheelwright, with extra thanks to Andy Vernon-Jones for the photographs.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("My wonderful family: my parents, Paul Phillips and Susan Zimmermann; my grandparents Paul Phillips Sr. and Mary Jane Zimmermann; my in-laws, Gail and Doug Thompson; my siblings-in-law, Peter Light, Raven Phillips, and Nate Thompson; my brother, Mark Phillips; my sister Katherine Phillips (you are still at my side); and my two dreamy little nieces. My sister Alice Light is the best adviser imaginable, in matters of both literature and life.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("My children, Ruth and Neal, “a detonation in my heart.” You’re where the fun is.")]), _vm._v(" "), _c('p', {
    staticClass: "BMTX"
  }, [_vm._v("Adam: Thank you for the past thirteen years. You know why this book is for you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-466fc50a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0